import { render, staticRenderFns } from "./FarmerAlwaysChoiceItem.vue?vue&type=template&id=29afe56b"
import script from "./FarmerAlwaysChoiceItem.vue?vue&type=script&lang=js"
export * from "./FarmerAlwaysChoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports